import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  display: flex;
`;

export const ContainerBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export const Content = styled.main`
  width: 100%;
  padding: 2rem;
`;

export const ContentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > p {
    font-size: 1.1rem;
    span {
      font-weight: 700;
      line-height: 1.3rem;
    }
  }
`;

export const AcessosConsolidadosContainer = styled.div`
  width: 100%;
  height: 68vh;
  overflow-y: scroll;
  background-color: var(--background-item);
  padding: 10px;
  border-radius: 0px 15px 15px 15px;

  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
`;

export const RegiaoContainer = styled.div`
  width: 100%;
  padding: 1rem 1rem 2rem 1rem;
  height: 100%;
  background: #fff;

  display: flex;
  flex-direction: column;

  align-items: center;
`;

export const RegiaoCard = styled.div`
  width: 100%;
  border-radius: 5px 0px 0px 5px;
  background: var(--background-item);

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RegiaoInfo = styled.div`
  height: 3.5rem;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  strong {
    font-size: 14px;
  }

  p {
    font-size: 12px;
  }
`;

interface PorcentagemProps {
  isState?: boolean;
}

export const Porcentagem = styled.div<PorcentagemProps>`
  width: 50px;
  height: 100%;
  border-radius: 0px 5px 5px 0px;
  background: ${(props) =>
    props.isState ? 'var(--percentage)' : 'var(--region-percentage)'};

  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 10px;
    font-weight: 700;
    color: var(--background);
  }
`;

export const AcessosEstadosContainer = styled.div`
  width: 100%;
  height: 66vh;
  background: #fff7df;
  /* margin: 0 2rem; */
  margin-bottom: 2rem;
  padding: 10px;
  border-radius: 0px 15px 15px 15px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EstadoContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #fff;
  padding: 1rem;
  border-radius: 5px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(9, 1fr);
  grid-auto-flow: column;

  gap: 1.3rem;
`;

export const Button = styled.button`
  background-color: #fff7df;
  border: 0;
  border-radius: 5rem;
  font-weight: 700;
`;

export const BackButton = styled.button`
  padding: 1rem 2rem;
  font-weight: 700;
  background-color: #fff7df;
  border: 0;
  font-size: 18px;
  display: flex;
  align-items: center;
  svg {
    color: var(--color-primary);
  }
`;

export const Footer = styled.footer`
  width: 100%;
  height: 60px;
  position: relative;
  bottom: 0;
  background: var(--background);
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
`;
